import { render, staticRenderFns } from "./ModalTechicalInfo.vue?vue&type=template&id=830f7d08&scoped=true&"
import script from "./ModalTechicalInfo.vue?vue&type=script&lang=ts&"
export * from "./ModalTechicalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTechicalInfo.vue?vue&type=style&index=0&id=830f7d08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830f7d08",
  null
  
)

export default component.exports